import { Directive, ElementRef, HostListener, AfterViewInit, Optional, Self } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({ selector: '[thousandSep]' })
export class ThousandSeparatorDirective implements AfterViewInit {

  constructor(private el: ElementRef, @Optional() @Self() private control: NgControl) {}

  ngAfterViewInit() {
    // setTimeout pour laisser ngModel lier la valeur avant de formater
    setTimeout(() => {
      const val = this.el.nativeElement.value;
      if (val) {
        this.el.nativeElement.value = this.format(val);
      }
    }, 0);
  }

  private format(value: any): string {
    const raw = String(value || '').replace(/\s/g, '').replace(/[^\d.]/g, '');
    if (!raw) return '';
    const parts = raw.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '\u00a0');
    return parts.join('.');
  }

  private unformat(value: string): string {
    return String(value || '').replace(/[\s\u00a0]/g, '');
  }

  @HostListener('focus')
  onFocus() {
    this.el.nativeElement.value = this.unformat(this.el.nativeElement.value);
  }

  @HostListener('blur')
  onBlur() {
    const raw = this.unformat(this.el.nativeElement.value);
    this.el.nativeElement.value = this.format(raw);
    if (this.control?.control) {
      this.control.control.setValue(raw, { emitEvent: false });
    }
  }
}
